module.exports = __webpack_public_path__ + "img/index-t-slide2.dccbc44f.png";